export { getUrlHash } from './get-url-hash';
